import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'

import constPlugin from './plugins/constPlugin'
Vue.use(constPlugin)

// Install BootstrapVue
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: () => {
    store.subscribe((mutation, state) => {
      // Store the ingredients in localstorage!
      localStorage.setItem('ingredients', JSON.stringify(state.ingredients.ingredients))
    })
  },
  render: h => h(App)
}).$mount('#app')
